import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { EthAbsData } from "../models/eth-abs-data";
import { catchError, Observable } from "rxjs";
import { CropBioKMaxData } from "../models/crop-bio-k-max-data";
import { MacroNutrientData } from "../models/macro-nutrient-data";
import { MicroNutrientData } from "../models/micro-nutrient-data-";
import { GibbPPMData } from "../models/gibb-ppm-data";
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SyncService extends BaseService {

    private FMS_URL = environment.apiAdminBaseUrl + "fms";

    hasTenantFmsData(tenantId: number): Observable<boolean> {
        const params = new HttpParams().set('tenantId', tenantId.toString());
        return this.httpClient.get<boolean>(this.FMS_URL + '/check', { params });
    }

    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    getEthAbsStats(fieldId: String, fromDate: String, toDate: String): Observable<EthAbsData> {
        return this.httpClient.get<EthAbsData>(this.FMS_URL + `/eth-abs-per-ha?fieldId=${fieldId}&fromDate=${fromDate}&toDate=${toDate}`)
            .pipe(
                catchError((err) => {
                    return this.errorHandler(err);
                })
            );
    }

    getCropBioKMaxStats(fieldId: String, fromDate: String, toDate: String): Observable<CropBioKMaxData> {
        return this.httpClient.get<CropBioKMaxData>(this.FMS_URL + `/crop-bio-kmax-per-ha?fieldId=${fieldId}&fromDate=${fromDate}&toDate=${toDate}`)
            .pipe(
                catchError((err) => {
                    return this.errorHandler(err);
                })
            );
    }

    getMacroNutrientStats(fieldId: String, fromDate: String, toDate: String): Observable<MacroNutrientData> {
        return this.httpClient.get<MacroNutrientData>(this.FMS_URL + `/macro-nutrients-per-ha?fieldId=${fieldId}&fromDate=${fromDate}&toDate=${toDate}`)
            .pipe(
                catchError((err) => {
                    return this.errorHandler(err);
                })
            );
    }

    getMicroNutrientStats(fieldId: String, fromDate: String, toDate: String): Observable<MicroNutrientData> {
        return this.httpClient.get<MicroNutrientData>(this.FMS_URL + `/micro-nutrients-per-ha?fieldId=${fieldId}&fromDate=${fromDate}&toDate=${toDate}`)
            .pipe(
                catchError((err) => {
                    return this.errorHandler(err);
                })
            );
    }

    getGibbPPM(fieldId: String, fromDate: String, toDate: String): Observable<GibbPPMData> {
        return this.httpClient.get<GibbPPMData>(this.FMS_URL + `/gibb-ppm?fieldId=${fieldId}&fromDate=${fromDate}&toDate=${toDate}`)
            .pipe(
                catchError((err) => {
                    return this.errorHandler(err);
                })
            );
    }

    getFieldInfo(fieldId: String, cropYear: number): Observable<{ crop: string, cultivar: string }> {
        return this.httpClient.get<{ crop: string, cultivar: string }>(this.FMS_URL + `/field-info?fieldId=${fieldId}&cropYear=${cropYear}`)
            .pipe(
                catchError((err) => {
                    return this.errorHandler(err);
                })
            );
    }
}